"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../../theme");
const common_styled_components_1 = require("../common-styled-components");
const ship_intensity_low_png_1 = __importDefault(require("../../../images/ship-intensity-low.png"));
const FooterContainer = styled_components_1.default.footer `
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid ${theme_1.theme.colors.grey(4)};
  padding: ${theme_1.theme.spacing(4)};
  margin: ${theme_1.theme.spacing(6)} 0 0 0;
  background-color: white;
  border-bottom-right-radius: ${common_styled_components_1.DEFAULT_RADIUS};

  @media (max-width: ${theme_1.breakpoints.tablet}px) {
    border-bottom-left-radius: ${common_styled_components_1.DEFAULT_RADIUS};
  }

  @media (max-width: ${theme_1.breakpoints.mobilePlus}px) {
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: ${theme_1.theme.spacing(3)} 0;
    border-radius: 0;
  }
`;
const FooterThings = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: ${(p) => (p.align === "left" ? "flex-start" : "flex-end")};
`;
const ShipImage = styled_components_1.default.img `
  height: 48px;
  margin-right: ${theme_1.theme.spacing(2)};
`;
const Footer = ({ children }) => {
    return ((0, jsx_runtime_1.jsxs)(FooterContainer, { children: [(0, jsx_runtime_1.jsx)(FooterThings, { align: "left", children: (0, jsx_runtime_1.jsx)(ShipImage, { src: ship_intensity_low_png_1.default }) }), (0, jsx_runtime_1.jsxs)(FooterThings, { align: "right", children: [children, (0, jsx_runtime_1.jsx)(common_styled_components_1.P, { children: "\u00A9 Ahti Climate" })] })] }));
};
exports.Footer = Footer;
